import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
export const ENTITY_SHARE_QUERY_KEY = ["entity-share"];
export const entityShareQueryKey = (entityGRN) => [...ENTITY_SHARE_QUERY_KEY, entityGRN != null ? entityGRN : "new"];
const useEntityShareState = (entityGRN) => useQuery({
  queryKey: entityShareQueryKey(entityGRN),
  // queryFn is a noop because consumers populate the cache via the setEntityShareState helper below
  queryFn: () => void 0,
  enabled: false,
  initialData: void 0
});
export const useSetEntityShareState = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (entityGRN, state) => {
      queryClient.setQueryData(entityShareQueryKey(entityGRN), state);
    },
    [queryClient]
  );
};
export default useEntityShareState;
